import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTimeComponent } from "./med-icon-time.component";

@NgModule({
  declarations: [
    MedIconTimeComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTimeComponent,
  ],
})
export class MedIconTimeModule { }
